import React from "react"

import { DraggableCore } from "react-draggable"
import styled from "styled-components"

const StyledWrapper = styled.div`
  position: absolute;
  border: 1px solid white;
  background-color: red;
  border-radius: 6px;
  overflow: hidden;
  z-index: 999;
`

const DraggableContainer_Internal: React.FC<{
  children: React.ReactNode
  handleClassName?: string
  Wrapper?: React.FC<React.HTMLAttributes<HTMLDivElement>>
}> = ({ children, Wrapper = StyledWrapper, handleClassName = `handle` }) => {
  const nodeRef = React.useRef<HTMLDivElement>(null)
  const [position, setPosition] = React.useState({ x: 0, y: 0 })

  return (
    <DraggableCore
      onDrag={(_, data) => {
        setPosition((prev) => {
          const newPosition = {
            x: prev.x + data.deltaX,
            y: prev.y + data.deltaY,
          }
          if (newPosition.y < 0) newPosition.y = 0
          if (newPosition.x < -100) newPosition.x = -100
          if (newPosition.x > window.innerWidth - 100) {
            newPosition.x = window.innerWidth - 100
          }
          if (newPosition.y > window.innerHeight - 100) {
            newPosition.y = window.innerHeight - 100
          }

          return newPosition
        })
      }}
      handle={`.${handleClassName}`}
      nodeRef={nodeRef}
      disabled={false}
    >
      <Wrapper
        ref={nodeRef}
        style={{
          top: position.y,
          left: position.x,
        }}
      >
        {children}
      </Wrapper>
    </DraggableCore>
  )
}

export const DraggableContainer = React.memo(DraggableContainer_Internal)
